import {
  getCurrentProfileSelect,
  PROFILE_KEY
} from '@gymaholic/packages'
import getValueReduxUtil from 'modules/redux/utils/get-value'
import { createSelector } from 'reselect'

const getTrainingFrequencyProfileSelect = createSelector(
  getCurrentProfileSelect,
  (profile) => (
    getValueReduxUtil(profile, PROFILE_KEY.TRAINING_FREQUENCY)
  )
)

export default getTrainingFrequencyProfileSelect
